const jobs = {
  forms: {
    information: {
      reservationDetails: {
        fields: {
          from: 'מיקום איסוף',
          to: 'מיקום משלוח',
          seat: 'חבילות',
        },
      },
    },
  },

  table: {
    headers: {
      seats: 'כמות פריטים',
      from: 'מיקום איסוף',
      to: 'מיקום משלוח',
      passenger: 'שם מקבל',
    },
    statuses: {
      picked: 'במשלוח',
      dropped: 'נמסר',
      noshow: 'משלוח נכשל',
    },
  },
};

export default jobs;
